import type { DramaStatus, TimelineType } from '@/mocks/dramas';

export const STATUS_LABEL: Record<DramaStatus, string> = {
  ongoing: '进行中',
  twist: '反转中',
  ended: '已完结',
};

export const STATUS_STYLE: Record<DramaStatus, string> = {
  ongoing: 'border-secondary-300 bg-secondary-100 text-secondary-900',
  twist: 'border-primary-200 bg-primary-100 text-primary-800',
  ended: 'border-accent-300 bg-accent-100 text-accent-900',
};

export const TIMELINE_META: Record<
  TimelineType,
  { label: string; icon: string; dotClass: string; badgeClass: string }
> = {
  start: {
    label: '起始',
    icon: 'ri-flag-line',
    dotClass: 'bg-secondary-500',
    badgeClass: 'border-secondary-300 bg-secondary-100 text-secondary-900',
  },
  update: {
    label: '后续',
    icon: 'ri-refresh-line',
    dotClass: 'bg-accent-500',
    badgeClass: 'border-accent-300 bg-accent-100 text-accent-900',
  },
  twist: {
    label: '反转',
    icon: 'ri-alarm-warning-line',
    dotClass: 'bg-primary-500',
    badgeClass: 'border-primary-200 bg-primary-100 text-primary-800',
  },
  ending: {
    label: '结局',
    icon: 'ri-flag-2-line',
    dotClass: 'bg-foreground-700',
    badgeClass: 'border-background-300 bg-background-200 text-foreground-800',
  },
};

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)} 万`;
  }
  return String(heat);
}

export function categoryName(id: string): string {
  const map: Record<string, string> = {
    yule: '娱乐圈瓜',
    wanghong: '网红翻车',
    shangye: '商业互撕',
    keji: '科技圈瓜',
    zongyi: '综艺影视',
  };
  return map[id] || '综合瓜';
}